import { render, staticRenderFns } from "./WebRedirection.vue?vue&type=template&id=b4c468a2&scoped=true&"
import script from "./WebRedirection.vue?vue&type=script&lang=js&"
export * from "./WebRedirection.vue?vue&type=script&lang=js&"
import style0 from "./WebRedirection.vue?vue&type=style&index=0&id=b4c468a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c468a2",
  null
  
)

export default component.exports